module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Measure areas and distances":"Flächen und Entfernungen messen"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/measuretool/ToggleButton.vue
// module id = 1JX6
// module chunks = 1